export default {"src":"/_next/static/media/0xc2E9d07F66A89c44062459A47a0D2Dc038E4fb16.a5500068.svg","height":150,"width":152,"blurWidth":0,"blurHeight":0};